import { Box, Container, Stack } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CalcButton from '../components/Button';
import DropdownList from '../components/dropdownList';
import Result from '../components/Result';
import useGenesStore from '../store/store';
import { injectNoneGenes } from '../utils/inheritance';

export default function Main() {
  const { t } = useTranslation();
  const [maleGenes, setMaleGenes] = useState<string[]>([]);
  const [femaleGenes, setFemaleGenes] = useState<string[]>([]);
  const [wholeMaleGenes, setWholeMaleGenes] = useState<string[]>([]);
  const [wholeFemaleGenes, setWholeFemaleGenes] = useState<string[]>([]);

  const { setMaleGene, setFemaleGene, setResult } = useGenesStore();

  useEffect(() => {
    setWholeMaleGenes(
      [
        ...maleGenes,
        ...injectNoneGenes(maleGenes, femaleGenes).noneMaleGenes,
      ].sort((prev, cur) => {
        const [upperPrev, upperCur] = [prev.toUpperCase(), cur.toUpperCase()];
        if (upperPrev > upperCur) return 1;
        if (upperPrev < upperCur) return -1;
        return 0;
      }),
    );
    setWholeFemaleGenes(
      [
        ...femaleGenes,
        ...injectNoneGenes(maleGenes, femaleGenes).noneFemaleGenes,
      ].sort((prev, cur) => {
        const [upperPrev, upperCur] = [prev.toUpperCase(), cur.toUpperCase()];
        if (upperPrev > upperCur) return 1;
        if (upperPrev < upperCur) return -1;
        return 0;
      }),
    );
  }, [maleGenes, femaleGenes]);

  return (
    <Container
      size='sm'
      px='md'
      sx={{
        'width': '100%',
        'maxWidth': 640,
        'boxShadow': '0 0 2px 1px rgb(0 0 0 / 10%)',
        'paddingTop': 16,
        'paddingBottom': 16,
        'borderRadius': 8,
        '@media (min-width: 640px)': {
          paddingTop: 24,
          paddingBottom: 24,
          paddingLeft: 24,
          paddingRight: 24,
        },
      }}
    >
      <Stack
        spacing='md'
        sx={{
          'marginBottom': 16,
          '@media (min-width: 640px)': {
            flexDirection: 'row',
            alignItems: 'flex-end',
            marginBottom: 20,
          },
        }}
      >
        <Box sx={{ width: '100%', flex: 1, minWidth: 0 }}>
          <DropdownList title={t('male')} setGenes={setMaleGenes} />
        </Box>
        <Box sx={{ width: '100%', flex: 1, minWidth: 0 }}>
          <DropdownList title={t('female')} setGenes={setFemaleGenes} />
        </Box>
      </Stack>
      <Box sx={{ width: '100%' }}>
        <CalcButton
          wholeMaleGenes={wholeMaleGenes}
          wholeFemaleGenes={wholeFemaleGenes}
          onClick={() => {
            setMaleGene(maleGenes);
            setFemaleGene(femaleGenes);
          }}
          setResult={setResult}
        />
      </Box>
      <Result />
    </Container>
  );
}
